import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Menu } from '@doxyme/ui';
import { noop } from 'lodash';
import { TroubleshootingWizardHeader } from '../TroubleshootingWizardHeader';
import { TroubleshootingWizardInfo } from '../TroubleshootingWizardInfo';
import { TroubleshootingWizardActions } from '../TroubleshootingWizardActions';
import { useSelector, useDispatch } from 'react-redux';
import * as helpers from '../../helpers';
import * as selectors from '../../selectors';
import * as actions from '../../actions';
import './TroubleshootingWizard.scss';
export const TroubleshootingWizard = ({ onClose = noop, isPatient, }) => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const currentStepName = useSelector(selectors.getStepName);
    const flow = useMemo(() => helpers.getTroubleshootingFlow(isPatient), [isPatient]);
    const currentStep = flow[currentStepName];
    const close = () => {
        onClose();
        dispatch(actions.setStepName(null));
    };
    if (!currentStep)
        return null;
    return (<Menu className="troubleshooting-wizard">
      <TroubleshootingWizardHeader title={intl.formatMessage({ id: 'troubleshooting.wizard.title' })} onClose={close}/>
      <TroubleshootingWizardInfo items={currentStep.textItems}/>
      <TroubleshootingWizardActions actions={currentStep.actions}/>
    </Menu>);
};
